import React from 'react';
import { motion, MotionValue } from 'framer-motion';

interface ParallaxImagesProps {
    yPos: MotionValue<number>;
    IMAGES: { src: string; alt: string }[];
}

const ParallaxImages: React.FC<ParallaxImagesProps> = ({
    yPos,
    IMAGES,
}) => (
    <motion.div
        style={{ y: yPos }}
        className="absolute top-40 left-0 w-full h-auto min-h-[200px] sm:h-[60vh] lg:h-[80vh] overflow-hidden opacity-25 py-4 sm:py-10 flex flex-wrap gap-4 px-4 z-10"
    >
        {IMAGES.map((img, i) => (
            <div
                key={i}
                className="relative w-full sm:w-[48%] md:w-[32%] aspect-[16/9] rounded-3xl overflow-hidden shadow-2xl group"
            >
                <motion.img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 group-hover:brightness-90"
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                />
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-80 group-hover:opacity-100 transition" />
                {/* Optional caption */}
                <div className="absolute bottom-2 left-2 text-white font-semibold text-xs bg-black/40 px-3 py-1 rounded-full backdrop-blur-sm">
                    {img.alt}
                </div>
            </div>
        ))}
    </motion.div>
);

export default ParallaxImages; 